interface UpdateItem {
  date: string;
  time: string;
  title: string;
  chapter: string;
  category: string;
}

const updates: UpdateItem[] = [
  { date: '07-28', time: '15:30', title: '我的温柔暴君', chapter: '第89话', category: '韩漫' },
  { date: '07-28', time: '12:15', title: '重生之都市修仙', chapter: '第156话', category: '国漫' },
  { date: '07-28', time: '09:00', title: '邻家天使', chapter: '第67话', category: '日漫' },
  { date: '07-28', time: '07:45', title: '暗黑童话', chapter: '第42话', category: '韩漫' },
  { date: '07-27', time: '20:30', title: '剑道独尊', chapter: '第203话', category: '国漫' },
  { date: '07-27', time: '17:00', title: '末日生存指南', chapter: '第78话', category: '国漫' },
  { date: '07-27', time: '14:20', title: '恋爱百分百', chapter: '第34话', category: '韩漫' },
  { date: '07-27', time: '10:00', title: '妖怪公寓', chapter: '第55话', category: '日漫' },
  { date: '07-26', time: '22:15', title: '仙王的日常生活', chapter: '第112话', category: '国漫' },
];

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-600">实时追踪热门漫画更新动态</p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1.5 text-xs text-accent-600 font-medium">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-accent-500"></span>
            </span>
            实时更新中
          </span>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200 hidden sm:block"></div>
          <div className="space-y-0">
            {updates.map((item, idx) => (
              <a
                key={idx}
                href="#cards"
                className="group flex items-start gap-4 py-3 md:py-3.5 cursor-pointer"
              >
                <div className="relative z-10 flex-shrink-0 w-10 h-10 rounded-full bg-background-50 border-2 border-background-200 group-hover:border-primary-300 flex items-center justify-center transition-colors hidden sm:flex">
                  <span className="w-2 h-2 rounded-full bg-primary-400 group-hover:bg-primary-500 transition-colors"></span>
                </div>
                <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 p-3 rounded-md bg-background-50 border border-background-200 group-hover:border-primary-200 group-hover:bg-primary-50/20 transition-all duration-200">
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-xs font-mono text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className="text-xs font-mono text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 font-medium flex-shrink-0 w-fit">
                    {item.category}
                  </span>
                  <span className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </span>
                  <span className="text-xs text-primary-600 font-medium flex-shrink-0 whitespace-nowrap">
                    {item.chapter}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}